import { FC } from 'react';

import { useSelector } from '@hh.ru/front-static-app';

import ChartContent from 'src/components/VacancyConversionChart/ChartContent';
import NoVacancyData from 'src/components/VacancyConversionChart/NoVacancyData';

const VacancyConversionChart: FC = () => {
    const report = useSelector((state) => state.vacancyConversionStatistics);

    if (!report?.publications) {
        return <NoVacancyData vacancyId={report.vacancyId} />;
    }
    return <ChartContent report={report} />;
};

export default VacancyConversionChart;
